import Search from "./views/search-ajax/search-ajax.js";

const $ = require("jquery");

$(function () {
  const search = new Search({
    el: $("[data-search-ajax]"),
  });
});
